import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";  

const BackToDashboard = ({ dashboardPath = "/admin/AdminDashboard" }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();  

  const handleBack = () => {
    navigate(dashboardPath);
  };

  return (
    <Button
      variant="text"
      startIcon={<ArrowBackIcon />}
      onClick={handleBack}
      sx={{ mb: 2 }}
    >
      {t("return_to_dashboard") || "Return to Dashboard"}
    </Button>
  );
};

export default BackToDashboard;
